/* eslint-disable indent */
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Button, Icon, IconButton, Tooltip, Callout } from '@folio/stripes-components';
import { FormattedMessage, useIntl } from 'react-intl';
// import { ClipCopy } from '@folio/stripes/smart-components';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { ClipCopy } from '@folio/stripes/smart-components';
import css from './AuthoritySuggestions.css';

const propTypes = {
  suggestion: PropTypes.object.isRequired,
  onSelect: PropTypes.func.isRequired,
  isSelected: PropTypes.bool,
  getSourceFileNameById: PropTypes.func,
};

function SuggestionItem({
  suggestion,
  onSelect,
  isSelected,
  getSourceFileNameById,
}) {
  const intl = useIntl();
  const callout = useRef();

  const handleClick = () => {
    onSelect(suggestion);
  };

  // Handle mouse down to prevent blur from text field before click
  const handleMouseDown = (event) => {
    event.preventDefault(); // Prevent blur on text field
    onSelect(suggestion);
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onSelect(suggestion);
    }
  };

  const handleCopy = () => {
    callout.current?.sendCallout({
      type: 'success',
      message: (
        <FormattedMessage
          id="ui-plugin-inventory-templates.authority.copy.success"
          defaultMessage="{term} copied to clipboard successfully"
          values={{ term: suggestion?.headingRef || suggestion?.displayText }}
        />
      ),
    });
  };

  return (
    <div
      className={`${css.suggestionItem} ${isSelected ? css.selected : ''}`}
      role="button"
      tabIndex={0}
      data-testid="authority-suggestion-item"
    >
      <div className={css.suggestionContent}>
        <div className={css.headingRef}>
          <Icon icon="link" size="small" />
          <span className={css.headingText}>{suggestion.displayText}</span>
        </div>
        <div className={css.metadata}>
          {suggestion.headingType && (
            <span className={css.headingType}>
              <FormattedMessage
                id="ui-plugin-inventory-templates.authority.suggestion.type"
                defaultMessage="Type: {type}"
                values={{
                  type: suggestion.headingType
                    ? intl.formatMessage({
                        id: `ui-marc-authorities.authority.headingType.${suggestion.headingType.toLowerCase()}`,
                        defaultMessage: suggestion.headingType,
                      })
                    : '',
                }}
              />
            </span>
          )}
          <span className={css.sourceFile}>
            <FormattedMessage
              id="ui-plugin-inventory-templates.authority.suggestion.source"
              defaultMessage="Source: {source}"
              values={{
                source: (() => {
                  if (
                    !suggestion.sourceFileId ||
                    suggestion.sourceFileId === 'NULL' ||
                    suggestion.sourceFileId === 'null'
                  ) {
                    return (
                      <FormattedMessage
                        id="ui-plugin-inventory-templates.authority.source.unspecified"
                        defaultMessage="Unspecified"
                      />
                    );
                  }
                  return getSourceFileNameById
                    ? getSourceFileNameById(suggestion.sourceFileId) ||
                        suggestion.sourceFileId
                    : suggestion.sourceFileId;
                })(),
              }}
            />
          </span>
        </div>
      </div>
      <div className={css.actionButtons}>
        <>
          {/* <ClipCopy text={suggestion?.headingRef} /> */}
          <Tooltip
            id="copy-to-clipboard-tooltip"
            text={
              <FormattedMessage
                id="ui-plugin-inventory-templates.authority.suggestion.copy"
                defaultMessage="Copy to clipboard"
              />
            }
          >
            {({ ref, ariaIds }) => (
              <CopyToClipboard
                text={suggestion?.headingRef}
                onCopy={handleCopy}
              >
                <span data-test-copy-icon>
                  <IconButton
                    ref={ref}
                    icon="clipboard"
                    aria-labelledby={ariaIds.text}
                  />
                </span>
              </CopyToClipboard>
            )}
          </Tooltip>
        </>
        <Button
          buttonStyle="primary"
          size="small"
          onMouseDown={handleMouseDown}
          onClick={handleClick}
          data-testid="link-authority-button"
          marginBottom0
        >
          <FormattedMessage
            id="ui-plugin-inventory-templates.authority.suggestion.link"
            defaultMessage="Link"
          />
        </Button>
      </div>
      <Callout ref={callout} />
    </div>
  );
}

SuggestionItem.propTypes = propTypes;

export default SuggestionItem;
